import React from 'react';

import { AmbientProvider } from './ambient';

const AppProvider = ({ children }) => (
  <AmbientProvider>
    {children}
  </AmbientProvider>
)

export default AppProvider;